import { X } from "lucide-react";
import { useState } from "react";

/** iter471 37 — bouton « Filtres (NN) » (style rail rouge) : absent quand `count` = 0, remet tous les filtres à zéro au clic (sans confirm()). */
export default function FiltersResetButton({ count, onReset, testId = "filters-reset" }) {
  const [hov, setHov] = useState(false);
  if (!count) return null;
  return (
    <button type="button" onClick={onReset} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      className="inline-flex items-stretch text-xs transition-colors"
      style={{ background: "#141417", border: `1px solid ${hov ? "#DC2626" : "#7F1D1D"}`, borderRadius: 8, overflow: "hidden", padding: 0, boxSizing: "border-box" }}
      title="Réinitialiser tous les filtres" data-testid={testId} data-count={count}>
      <span className="inline-flex items-center justify-center shrink-0" style={{ width: 28, background: hov ? "#B91C1C" : "#DC2626", transition: "background-color .15s" }} data-testid={`${testId}-band`}>
        <X size={13} strokeWidth={2.2} color="#FFFFFF" />
      </span>
      <span className="inline-flex items-center tabular-nums" style={{ gap: 10, padding: "6px 12px 6px 10px", fontSize: 12, fontWeight: 600, lineHeight: "16px", color: "#FFFFFF", whiteSpace: "nowrap" }} data-testid={`${testId}-label`}>
        Filtres ({String(count).padStart(2, "0")})
      </span>
    </button>
  );
}
